import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M24 11.14s-3.41-.65-6.24 1.71c-2.6 2.17-3.66 4.81-4.88 6.64.24-.7.38-1.44.38-2.22v-6.22c4.69-.63 9.02-4.76 9.02-11.05-3.43 0-5.14 4.29-5.14 4.29S17.14 0 15.43 0 12 4.29 12 4.29 10.29 0 8.57 0C6.85 0 6.86 4.29 6.86 4.29S5.15 0 1.72 0c0 6.29 4.33 10.42 9.02 11.05v6.24c0 .44-.07.87-.2 1.27-1.02-1.73-2.12-3.88-4.3-5.71C3.41 10.48 0 11.14 0 11.14s2.08 7.69 9.43 9.19c-.75.71-1.76 1.14-2.87 1.14H0v2.52h6.54c2.52 0 4.7-1.38 5.86-3.43 9.12-.25 11.6-9.43 11.6-9.43v.01Z" />
  </>
);

const CollWildflowers = Icon('coll-wildflowers', svgContents);

export default CollWildflowers;
